import { orchestrator } from 'satcheljs';
import { connectOWAAccount } from 'owa-accounts-service';
import { startAddingAccount } from '../actions/internalActions';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';
import setAccountsEditorState from '../mutators/setAccountsEditorState';
import setSelectedAccountProvider from '../mutators/setSelectedAccountProvider';
import getAccountsEditorSource from '../selectors/getAccountsEditorSource';
import { logUsage } from 'owa-analytics';

orchestrator(startAddingAccount, ({ accountProviderType, isReconnectFlow }) => {
    const source = getAccountsEditorSource();
    logUsage(
        'connectAccount',
        {
            accountProvider_1: accountProviderType,
            source_2: source,
        },
        {
            isCore: true,
        }
    );
    setSelectedAccountProvider(accountProviderType);
    setAccountsEditorState(AccountsEditorState.Adding);
    connectOWAAccount(accountProviderType, source, isReconnectFlow);
});
